import { createApp } from 'vue';
import OtfToTtfConverter from '@/Components/OtfToTtfConverter.vue';
import '@styles/app.css';

createApp(OtfToTtfConverter).mount('#otf-to-ttf-converter');
